export default {
  title: "Error",
  notFound: "Page not found",
  goBack: "Go back home",
}
